import { Link, useHistory, useLocation } from 'react-router-dom'
import AvatarLink from '../../../../components/profile/avatarLink/avatarLink'
import paths from '../../../../paths'
import CommentForm from '../commentForm/CommentForm'
import React, { useEffect, useState } from 'react'

import styles from '../post/Post.module.sass'
import moment from 'moment-mini'
import { fetchComments, likePost, likePostCancel } from '../../../../store/ephemeral/ephemeralSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Popup from '../../../../components/ui/popup'
import { createPortal } from 'react-dom'
import PaginationLoader from '../../../../components/ui/paginationLoader/PaginationLoader'
import { openMenu } from '../../../../store/common/commonSlice'
import { RootState } from '../../../../store/rootReducer'
import { deleteComment } from '../../../../api/ephemeral'
import { isUserPro } from '../../../../utils/isUserPro'
import UserMenu from '../userMenu/UserMenu'

interface CommentProps {
    post: any
    comment: any
    isInPopup: any
    setIsFullPostOpen: any
    replyCommentId: any
    setReplyCommentId: any
    isReplyComment?: boolean
    last?: boolean
}

const Comment = ({
    post,
    comment,
    isInPopup,
    setIsFullPostOpen,
    replyCommentId,
    setReplyCommentId,
    isReplyComment = false,
    last = false
}: CommentProps) => {
    const [t] = useTranslation()

    const history = useHistory()
    const location = useLocation()
    const [isFullImageOpen, setIsFullImageOpen] = React.useState(false)

    const loggedIn = useSelector((state: RootState) => state.member.loggedIn)
    const user = useSelector((state: RootState) => state.member.user)

    const dispatch = useDispatch()

    const handleReply = () => {
        if (!replyCommentId || !isInPopup) {
            setReplyCommentId(comment.id)
            if (!isInPopup) {
                setIsFullPostOpen(true)
                history.replace(location.pathname + '?post=' + post.id)
            }
        } else {
            if (comment.id === replyCommentId) {
                setReplyCommentId(null)
            } else {
                setReplyCommentId(comment.id)
            }
        }
    }

    // @ts-ignore
    function findObjectById(obj, targetId: number) {
        if (obj.id === targetId) {
            return obj
        }

        if (obj.comments && Array.isArray(obj.comments)) {
            for (const comment of obj.comments) {
                // @ts-ignore
                const found = findObjectById(comment, targetId)
                if (found) {
                    return found
                }
            }
        }

        return null
    }

    const parentComment = comment.parent_id ? findObjectById(post, comment.parent_id) : null

    const getNextComments = () => {
        dispatch(fetchComments({ id: comment.id, offset: comment.currentLength }))
    }

    const [isPostLiked, setIsPostLiked] = React.useState(post && post.likes ? post.likes.includes(comment.id) : false)
    const [amountOfLikes, setAmountOfLikes] = React.useState<number>(comment.like_count)

    const handleLikePost = (e: { stopPropagation: () => void }) => {
        e.stopPropagation()
        if (!loggedIn) {
            dispatch(openMenu())
            return
        }
        if (isPostLiked) {
            dispatch(likePostCancel({ id: comment.id, parent_id: parentComment.id }))
            setIsPostLiked(false)
            setAmountOfLikes((prev) => prev - 1)
        } else {
            dispatch(likePost({ id: comment.id, parent_id: parentComment.id }))
            setIsPostLiked(true)
            setAmountOfLikes((prev) => prev + 1)
        }
    }

    const [currentComments, setCurrentComments] = useState(comment.comments)
    const [additionalComments, setAdditionalComments] = useState([])
    useEffect(() => {
        setCurrentComments(
            [...comment.comments, ...additionalComments].filter(
                (item, index, self) => index === self.findIndex((obj) => obj.id === item.id)
            )
        )
    }, [comment.comments.length, additionalComments.length])

    const [isMessageRemoving, setIsMessageRemoving] = useState(false)

    const [isMessageDeleted, setIsMessageDeleted] = React.useState(false)

    const handleDeleteMessage = async () => {
        const deleteMessageResponse = await deleteComment(comment.id)
        if (deleteMessageResponse.status === 'success') setIsMessageDeleted(true)
    }

    if (isMessageDeleted) return <></>

    const handleContextMenu = (e: { preventDefault: () => void }) => {
        e.preventDefault()
    }

    return (
        <>
            <div
                className={`${styles['reply']} ${isInPopup ? styles['reply_popup'] : ''} ${
                    isReplyComment ? styles['reply_comment'] : ''
                }`}
            >
                <AvatarLink nick={comment.user.nick} img={comment.user.avatar_url} />
                <div className={styles['commentBlock']}>
                    {user && post.user.id === user.id && (
                        <>
                            <div className={styles['menu']} onClick={() => setIsMessageRemoving(true)}>
                                <img src={require('../../../../assets/ic-close.svg')} />
                            </div>
                            {isMessageRemoving && (
                                <div className={styles['removingBlock']}>
                                    <span onClick={handleDeleteMessage}>{t('Remove this message')}</span>
                                    <span onClick={() => setIsMessageRemoving(false)}>{t('Cancel')}</span>
                                </div>
                            )}
                        </>
                    )}
                    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '4px' }}>
                        <div style={{ display: 'flex', gap: '4px' }}>
                            <Link
                                to={paths.profile.toPath({ nick: comment.user.nick })}
                                className={styles['author']}
                                style={{ wordBreak: 'break-word' }}
                            >
                                {comment.user.nick}
                            </Link>
                            {user && loggedIn && user.id !== comment.user.id ? (
                                <div className={`${styles['avatar_menu']}`}>
                                    <img src={require('../../../../assets/ic-more-three-dots.svg')} />
                                    <div
                                        className={`${styles['menu']} ${styles['menu_comment']} dotsMenu${
                                            last ? ' ' + styles['menu_last'] : ''
                                        }`}
                                    >
                                        <UserMenu post={comment} />
                                    </div>
                                </div>
                            ) : (
                                <></>
                            )}
                        </div>
                        {isReplyComment && parentComment ? (
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                    whiteSpace: 'nowrap',
                                    flexWrap: 'wrap'
                                }}
                            >
                                <span>{t('replied to')}</span>
                                <Link
                                    to={paths.profile.toPath({ nick: parentComment.user.nick })}
                                    className={styles['author']}
                                    style={{ wordBreak: 'break-word' }}
                                >
                                    {parentComment.user.nick}
                                </Link>
                            </div>
                        ) : null}
                    </div>
                    {comment.attachments.length > 0 ? (
                        <div className={styles['attachment']}>
                            <img
                                onContextMenu={handleContextMenu}
                                src={
                                    comment.status === 'hidden'
                                        ? require('../../../../assets/404.png')
                                        : loggedIn
                                        ? `${comment.attachments[0].thumbnail_url_pro}${
                                              isUserPro(user.member_type) ? '&_=1' : ''
                                          }`
                                        : comment.attachments[0].thumbnail_url
                                }
                                alt=""
                                onClick={() => setIsFullImageOpen(true)}
                            />
                        </div>
                    ) : (
                        <></>
                    )}
                    <div className={styles['commentText']} onClick={handleReply}>
                        {comment.content}
                        <div className={styles['like']}>
                            <img
                                src={
                                    isPostLiked
                                        ? require('../../../../assets/ic-like-filled.svg')
                                        : require('../../../../assets/ic-like.svg')
                                }
                                onClick={handleLikePost}
                            />
                            <span>{amountOfLikes ? amountOfLikes : ''}</span>
                        </div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}
                        onClick={handleReply}
                    >
                        <div style={{ fontSize: '12px', color: 'var(--grey-dark-color)' }}>
                            {moment(comment.creation_time * 1000).isAfter(moment().subtract(1, 'days'))
                                ? moment(comment.creation_time * 1000).format('HH:mm')
                                : moment(comment.creation_time * 1000).format('DD.MM.YYYY - HH:mm')}
                        </div>
                        {post.status !== 'hidden' && (
                            <div
                                style={{
                                    fontSize: '12px',
                                    fontWeight: 'bold',
                                    color: 'var(--main-theme-color)',
                                    cursor: 'pointer'
                                }}
                            >
                                {t('reply')}
                            </div>
                        )}
                    </div>
                    {replyCommentId === comment.id && isInPopup && (
                        <div style={{ marginTop: '8px', width: '100%' }}>
                            <CommentForm
                                isReply
                                post={comment}
                                setAdditionalComments={setAdditionalComments}
                                closeReply={() => setReplyCommentId(null)}
                            />
                        </div>
                    )}
                </div>
            </div>
            {isInPopup &&
                currentComments.length > 0 &&
                currentComments.map((re: any) => (
                    <React.Fragment key={re.id}>
                        <Comment
                            post={post}
                            comment={re}
                            setIsFullPostOpen={setIsFullPostOpen}
                            isInPopup
                            setReplyCommentId={setReplyCommentId}
                            replyCommentId={replyCommentId}
                            isReplyComment
                        />
                    </React.Fragment>
                ))}
            {comment.commentsLoading ? <PaginationLoader /> : <></>}
            {isInPopup && comment.hasMoreComments && !comment.commentsLoading ? (
                <div
                    style={{
                        marginLeft: '40px',
                        color: 'var(--main-theme-color)',
                        cursor: 'pointer',
                        fontWeight: 'bold'
                    }}
                    onClick={getNextComments}
                >
                    {t('Load more')}
                </div>
            ) : (
                <></>
            )}
            {isFullImageOpen && typeof window !== 'undefined' ? (
                createPortal(
                    <Popup onClose={() => setIsFullImageOpen(false)} title={''} classname={styles['fullscreenPopup']}>
                        <img
                            onContextMenu={handleContextMenu}
                            src={
                                loggedIn
                                    ? `${comment.attachments[0].url_pro}${isUserPro(user.member_type) ? '&_=1' : ''}`
                                    : comment.attachments[0].url
                            }
                            alt=""
                        />
                    </Popup>,
                    document.body
                )
            ) : (
                <></>
            )}
        </>
    )
}

export default Comment
